import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {Card, CardText} from 'material-ui/Card'; // Remove unused CardTitle, CardActions
import Listing from './Listing';
import AddressInput from '../components/AddressInput';
// Remove unused imports:
// import avatar from './avatar.svg';
// import Dialog from 'material-ui/Dialog';
// import Toggle from 'material-ui/Toggle';
// import Checkbox from 'material-ui/Checkbox';
// import Slider from 'material-ui/Slider';
// import FlatButton from 'material-ui/FlatButton'
// import FontIcon from 'material-ui/FontIcon';
// import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';
import LazyLoad, { forceCheck } from 'react-lazyload';

const cardStyle = {
    marginBottom: 30,
    // Remove any width constraints
    height: 'auto', // Change from 100% if it's causing issues
    display: 'flex',
    flexDirection: 'column'
};

const muiTheme = getMuiTheme({
    fontFamily: 'Inter, Inter UI, sans-serif',
    palette: {
        primary1Color: '#ff8551', // Brand primary
        primary2Color: '#f76164'  // Brand secondary
    }
});
const menuItemStyle = {
    color: '#ff8551' // Brand primary
}

const storageTypes = ['All', 'Indoor Storage', 'Outdoor Storage', 'Parking Space'];
const minAreaOptions = [
    { value: 'Any', label: 'Any size' },
    { value: '5', label: '5m² or larger' },
    { value: '10', label: '10m² or larger' },
    { value: '15', label: '15m² or larger' },
    { value: '20', label: '20m² or larger' },
    { value: '30', label: '30m² or larger' },
    { value: '50', label: '50m² or larger' }
];
// Areas array removed - now using address input instead of dropdown

var defaultFilter = {
    type: 'All', // Set default to "All"
    order: 'RECOMMENDED', // Campaign priority applies only to the recommended sort
    min_area: null,
    start_date: null,
    end_date: null,
    address: null,
    lat: null,
    lng: null,
    radius: 50 // Default 50km radius
};

if (window.listing) {
    defaultFilter.type = listing.type;
}

var queryStringType = getQueryString('type');
if (queryStringType) {
    defaultFilter.type = queryStringType;
}

// Parse address-based location parameters
var queryStringAddress = decodeURIComponent(getQueryString('address') || '').replace(/\+/g, ' ');
if (queryStringAddress && queryStringAddress !== 'null') {
    defaultFilter.address = queryStringAddress;
}

var queryStringLat = getQueryString('lat');
if (queryStringLat) {
    defaultFilter.lat = parseFloat(queryStringLat);
}

var queryStringLng = getQueryString('lng');
if (queryStringLng) {
    defaultFilter.lng = parseFloat(queryStringLng);
}

var queryStringRadius = getQueryString('radius');
if (queryStringRadius) {
    defaultFilter.radius = parseFloat(queryStringRadius);
}

var queryStringMinArea = getQueryString('min_area');
if (queryStringMinArea) {
    defaultFilter.min_area = parseFloat(queryStringMinArea);
}

var queryStringOrder = getQueryString('order');
if (queryStringOrder) {
    defaultFilter.order = queryStringOrder;
}

// ... rest of code ...

var filter = _.cloneDeep(defaultFilter);

// Helper function to update URL parameters when filters change
function updateURLParams(filter) {
    const url = new URL(window.location);
    const params = url.searchParams;
    
    // Clear existing filter parameters
    ['location', 'address', 'lat', 'lng', 'radius', 'min_area', 'start_date', 'end_date', 'order', 'type'].forEach(param => {
        params.delete(param);
    });
    
    // Add current filter parameters
    if (filter.address) {
        params.set('address', filter.address);
    }
    if (filter.lat) {
        params.set('lat', filter.lat);
    }
    if (filter.lng) {
        params.set('lng', filter.lng);
    }
    if (filter.radius && filter.radius !== 50) {
        params.set('radius', filter.radius);
    }
    if (filter.min_area) {
        params.set('min_area', filter.min_area);
    }
    if (filter.start_date) {
        params.set('start_date', filter.start_date);
    }
    if (filter.end_date) {
        params.set('end_date', filter.end_date);
    }
    if (filter.order && filter.order !== 'RECOMMENDED') {
        params.set('order', filter.order);
    }
    if (filter.type && filter.type !== 'All') {
        params.set('type', filter.type);
    }
    
    // Update URL without page reload
    window.history.replaceState({}, '', url.toString());
}

// Helper function to validate and normalize date format
function validateAndNormalizeDateFormat(dateString) {
    if (!dateString) return null;
    
    // If already in ISO format (YYYY-MM-DD), return as-is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
    }
    
    // Try to parse various formats and convert to ISO
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            console.warn('Invalid date format:', dateString);
            return null;
        }
        
        // Convert to ISO format (YYYY-MM-DD)
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const isoFormat = `${year}-${month}-${day}`;

        return isoFormat;
    } catch (error) {
        console.warn('Failed to parse date:', dateString, error);
        return null;
    }
}

// Parse dates from URL parameters
var queryStringStartDate = getQueryString('start_date');
if (queryStringStartDate) {
    // Validate and normalize the date format
    const normalizedStartDate = validateAndNormalizeDateFormat(queryStringStartDate);
    if (normalizedStartDate) {
        defaultFilter.start_date = normalizedStartDate;
    } else {
        console.warn('Invalid start_date in URL, ignoring:', queryStringStartDate);
    }
}

var queryStringEndDate = getQueryString('end_date');
if (queryStringEndDate) {
    // Validate and normalize the date format
    const normalizedEndDate = validateAndNormalizeDateFormat(queryStringEndDate);
    if (normalizedEndDate) {
        defaultFilter.end_date = normalizedEndDate;
    } else {
        console.warn('Invalid end_date in URL, ignoring:', queryStringEndDate);
    }
}

var filter = _.cloneDeep(defaultFilter);

window.defaultListings = [];

// Helper function to find the nearest min area option for the dropdown
function getNearestMinAreaOption(targetArea) {
    if (!targetArea) return 'Any';

    // Convert to number
    const targetValue = parseFloat(targetArea);
    
    // Get numeric values from minAreaOptions (excluding 'Any'), sorted ascending
    const numericOptions = minAreaOptions
        .filter(option => option.value !== 'Any')
        .map(option => parseFloat(option.value))
        .sort((a, b) => a - b);
    
    // Find the largest option that is still <= targetArea (next lowest)
    let selectedOption = 'Any';
    
    for (const option of numericOptions) {
        if (option <= targetValue) {
            selectedOption = option.toString();
        } else {
            break; // Stop when we find one that's larger
        }
    }

    return selectedOption;
}

// Area parsing cache to avoid repeated regex operations
const areaParsingCache = new Map();

// Helper function to parse area string and convert to numeric value (with caching)
function parseAreaToNumber(areaString) {
    if (!areaString || typeof areaString !== 'string') {
        return null;
    }
    
    // Check cache first
    if (areaParsingCache.has(areaString)) {
        return areaParsingCache.get(areaString);
    }
    
    let result = null;
    
    // Handle calculated area (width x length = area)
    const dimensionMatch = areaString.match(/(\d+(?:\.\d+)?)\s*m?\s*x\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (dimensionMatch) {
        const width = parseFloat(dimensionMatch[1]);
        const length = parseFloat(dimensionMatch[2]);
        result = width * length;
    }
    // Handle direct area measurement (e.g., "12.5 m2", "12.5m²", "12.5 square meters")
    else {
        const areaMatch = areaString.match(/(\d+(?:\.\d+)?)\s*(?:m[²2]?|square\s*meters?)/i);
        if (areaMatch) {
            result = parseFloat(areaMatch[1]);
        } else {
            // Handle just a number
            const numberMatch = areaString.match(/(\d+(?:\.\d+)?)/);
            if (numberMatch) {
                result = parseFloat(numberMatch[1]);
            }
        }
    }
    
    // Cache the result
    areaParsingCache.set(areaString, result);
    return result;
}

class Listings extends Component {    constructor(props) {
        super(props);
        this.state = {
            listings: [],
            filter: filter,
            isLoadingWithDates: false
        };

        this.toggleType = (event, index, value) => {
            // Create a new filter object to avoid mutations
            const newFilter = {
                ...this.state.filter,
                type: value
            };

            this.setState({filter: newFilter}, () => {
                // Update URL to persist filter state
                updateURLParams(this.state.filter);
                
                // Use filterWithDates to preserve date filters
                this.filterWithDates();
                
                // Sync map dropdown and filter map if present
                const $mapDropdown = window.$ ? window.$('#mapPropertyType') : null;
                if ($mapDropdown && $mapDropdown.length) {
                    $mapDropdown.val(value);
                    $mapDropdown.trigger('change');
                }
                
                if (window.map && typeof window.populateMapWithListings === 'function') {
                    window.populateMapWithListings(window.map, value, this.state.filter);
                }
            });
        };

        // Add new address-based location handler
        this.handleAddressChange = (addressData) => {
            if (addressData && addressData.coordinates) {
                // Only update location-related fields, preserve all other filters
                const newFilter = {
                    ...this.state.filter,
                    address: addressData.address,
                    lat: addressData.coordinates.lat,
                    lng: addressData.coordinates.lng,
                    order: this.state.filter.order
                    // Keep existing type, min_area, start_date, end_date intact
                };
                this.setState({ filter: newFilter }, () => {
                    // Update URL to persist filter state
                    updateURLParams(this.state.filter);

                    // Use appropriate filtering method based on whether dates are set
                    this.filterWithDates();
                });
            } else {
                // Clear address filters but keep other filters intact
                const newFilter = {
                    ...this.state.filter,
                    address: null,
                    lat: null,
                    lng: null,
                    // Distance sort is meaningless without coordinates
                    order: this.state.filter.order === 'DISTANCE_ASC' ? 'RECOMMENDED' : this.state.filter.order
                };
                this.setState({ filter: newFilter }, () => {
                    // Update URL to persist filter state
                    updateURLParams(this.state.filter);

                    this.filterWithDates();
                });
            }
        };

        this.toggleOrder = (event, index, value) => {
            let filter = this.state.filter;
            filter.order = value;
            this.setState({filter: filter}, () => {
                // Update URL to persist filter state
                updateURLParams(this.state.filter);
                
                // Use filterWithDates to preserve date filters
                this.filterWithDates();
            });
        };        this.toggleMinArea = (event, index, value) => {
            let filter = this.state.filter;
            filter.min_area = value === 'Any' ? null : parseFloat(value);
            this.setState({filter: filter}, () => {
                // Update URL to persist filter state
                updateURLParams(this.state.filter);
                
                // Use filterWithDates to preserve date filters
                this.filterWithDates();
                
                // Sync map min size filter
                const $mapMinSize = window.$ ? window.$('#mapMinSize') : null;
                if ($mapMinSize && $mapMinSize.length) {
                    $mapMinSize.val(value);
                }
                
                // Update map with new filter
                if (window.map && typeof window.populateMapWithListings === 'function') {
                    window.populateMapWithListings(window.map, this.state.filter.type, this.state.filter);
                }
            });
        };        this.handleDateChange = (dateType, value) => {
            let filter = this.state.filter;
            const previousStartDate = filter.start_date;
            const previousEndDate = filter.end_date;
            
            // Validate and normalize the date format if value is provided
            let normalizedValue = value;
            if (value) {
                normalizedValue = validateAndNormalizeDateFormat(value);
                if (!normalizedValue) {
                    console.warn(`Invalid date format for ${dateType}:`, value);
                    return; // Don't update state with invalid date
                }
            }
            
            filter[dateType] = normalizedValue;
            this.setState({filter: filter}, () => {
                // Update URL to persist filter state
                updateURLParams(this.state.filter);
            });
            
            // Clear both dates if start date is cleared
            if (dateType === 'start_date' && !normalizedValue) {
                filter.end_date = '';
                this.setState({filter: filter}, () => {
                    // Update URL to persist filter state
                    updateURLParams(this.state.filter);
                    
                    // Update map
                    const $mapEndDate = window.$ ? window.$('#mapEndDate') : null;
                    const $mapClearDates = window.$ ? window.$('#mapClearDates') : null;
                    if ($mapEndDate && $mapEndDate.length) {
                        $mapEndDate.val('');
                    }
                    if ($mapClearDates && $mapClearDates.length) {
                        $mapClearDates.hide();
                    }
                });
            }
            
            // Optimize: only trigger API call if dates actually changed meaningfully
            const datesChanged = (filter.start_date !== previousStartDate) || (filter.end_date !== previousEndDate);
            
            if (!datesChanged) return;
            
            // Debounce the filter call for better performance
            if (this.dateFilterTimeout) {
                clearTimeout(this.dateFilterTimeout);
            }
            
            // Reduce debounce time for better responsiveness
            this.dateFilterTimeout = setTimeout(() => {
                this.filterWithDates();
                
                // Update map with new filter after API call
                if (window.map && typeof window.populateMapWithListings === 'function') {
                    window.populateMapWithListings(window.map, this.state.filter.type, this.state.filter);
                }
            }, 300); // Reduced from 500ms to 300ms
        };

        // Expose global function to get current filter state for map sync
        window.getCurrentListingsFilter = () => {
            return this.state.filter;
        };

        // Expose global function to set filter from map
        window.setListingsFilter = (mapFilter) => {
            const newFilter = {
                ...this.state.filter,
                type: mapFilter.type || this.state.filter.type,
                min_area: mapFilter.min_area
            };
            
            // Only update dates if they're explicitly provided in mapFilter
            if (mapFilter.hasOwnProperty('start_date')) {
                newFilter.start_date = mapFilter.start_date;
            }
            if (mapFilter.hasOwnProperty('end_date')) {
                newFilter.end_date = mapFilter.end_date;
            }
            
            this.setState({ filter: newFilter }, () => {
                updateURLParams(this.state.filter);
                this.filterWithDates();
            });
        };

        // Expose global function to set type filter from map
        window.setListingsTypeFilter = (type) => {
            const newFilter = { ...this.state.filter, type: type };
            this.setState({ filter: newFilter }, () => {
                updateURLParams(this.state.filter);
                this.filter();
            });
        };

        // Expose global function to set min area filter from map
        window.setListingsMinAreaFilter = (minArea) => {
            const newFilter = { ...this.state.filter, min_area: minArea };
            this.setState({ filter: newFilter }, () => {
                updateURLParams(this.state.filter);
                this.filter();
            });
        };

        this.filterWithDates = () => {
            // If dates are provided, use API call for real-time availability
            if (this.state.filter.start_date) {
                this.fetchListingsWithDates();
            } else {
                // Use regular client-side filtering
                this.filter();
            }
        };        this.fetchListingsWithDates = () => {
            // Cancel previous request if it exists
            if (this.currentRequest) {
                this.currentRequest.cancel('New request initiated');
            }
            
            // Set loading state
            this.setState({ isLoadingWithDates: true });
            
            const params = new URLSearchParams();
            
            // Add all filter parameters
            if (this.state.filter.start_date) params.append('start_date', this.state.filter.start_date);
            if (this.state.filter.end_date) params.append('end_date', this.state.filter.end_date);
            if (this.state.filter.type && this.state.filter.type !== 'All') {
                params.append('space_type', this.state.filter.type);
            }
            if (this.state.filter.min_area) {
                params.append('min_area', this.state.filter.min_area);
            }
            
            // Add coordinate-based location parameters
            if (this.state.filter.lat && this.state.filter.lng) {
                params.append('lat', this.state.filter.lat);
                params.append('lng', this.state.filter.lng);
                params.append('radius', this.state.filter.radius || 50);
            }

            // Create cancelable request
            const source = axios.CancelToken.source();
            this.currentRequest = source;

            axios.get(`/api/listings/filter?${params.toString()}`, {
                cancelToken: source.token
            })
                .then(result => {
                    let listings = result.data;

                    // Single-pass processing for better performance
                    const processedListings = this.processSinglePassFilter(listings);

                    this.setState({ listings: processedListings, isLoadingWithDates: false });
                    this.currentRequest = null;

                    // Update map with current filter
                    if (window.map && typeof window.populateMapWithListings === 'function') {
                        window.populateMapWithListings(window.map, this.state.filter.type, this.state.filter);
                    }
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        // Request was cancelled, do nothing
                        return;
                    }
                    console.error('Error fetching listings with dates:', error);
                    // Clear loading state and fallback to regular filtering
                    this.setState({ isLoadingWithDates: false });
                    this.currentRequest = null;
                    this.filter();
                });
        };

        this.fetchListings = () => {
            const { filter } = this.state;
            
            // Show loading indicator if dates are selected
            if (filter.start_date && filter.end_date) {
                this.setState({ isLoadingWithDates: true });
            }

            let url = '/api/listings/filter';
            let params = Object.assign({}, filter);

            if (params.area && params.area.id !== undefined) {
                params.area_id = params.area.id;
                delete params.area;
            }
            
            // Add coordinate parameters if available
            if (filter.lat && filter.lng) {
                params.lat = filter.lat;
                params.lng = filter.lng;
                params.radius = filter.radius || 50;
            }

            axios.get(url, { params: params })
                .then(response => {
                    this.setState({
                        listings: response.data,
                        isLoadingWithDates: false  // Clear loading state
                    });
                })
                .catch(error => {
                    console.error('Error fetching listings:', error);
                    this.setState({ isLoadingWithDates: false });  // Clear loading state on error
                });
        };        this.filter = (event, value) => {
            let listings = [...window.defaultListings]; // Use spread instead of deep clone for better performance
            
            // Use single-pass filtering for better performance
            const processedListings = this.processSinglePassFilterLocal(listings);
            
            this.setState({ listings: processedListings });
              // Update map with current filter
            if (window.map && typeof window.populateMapWithListings === 'function') {
                window.populateMapWithListings(window.map, this.state.filter.type, this.state.filter);
            }
        };        // Optimized single-pass filtering for local/cached data
        this.processSinglePassFilterLocal = (listings) => {
            const { filter } = this.state;
            const availableListings = [];
            const unavailableListings = [];
            
            // Helper function to calculate distance using Haversine formula
            const calculateDistance = (listing) => {
                if (!filter.lat || !filter.lng) return null;
                
                const listingLat = listing.latitude;
                const listingLng = listing.longitude;
                
                if (!listingLat || !listingLng) return null;
                
                // Haversine formula for distance calculation
                const R = 6371; // Earth's radius in kilometers
                const dLat = (listingLat - filter.lat) * Math.PI / 180;
                const dLng = (listingLng - filter.lng) * Math.PI / 180;
                const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(filter.lat * Math.PI / 180) * Math.cos(listingLat * Math.PI / 180) *
                    Math.sin(dLng / 2) * Math.sin(dLng / 2);
                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                const distance = R * c;
                
                return distance;
            };
            
            // Single pass through listings - filter and categorize simultaneously
            for (let i = 0; i < listings.length; i++) {
                const listing = listings[i];
                
                // Apply distance filter if coordinates are provided
                if (filter.lat && filter.lng) {
                    const distance = calculateDistance(listing);
                    const radius = filter.radius || 50; // Default 50km
                    
                    // Skip listings that are too far away or have no coordinates
                    if (distance === null || distance > radius) {
                        continue;
                    }
                    
                    // Store the distance on the listing for sorting
                    listing.calculatedDistance = distance;
                }
                
                // Apply type filter
                if (filter.type && filter.type !== 'All') {
                    if (filter.type === 'Workshop' && !listing.workshop) continue;
                    if (filter.type !== 'Workshop' && filter.type !== listing.features?.type) continue;
                }
                
                // Apply area filter
                if (filter.min_area) {
                    const listingArea = listing.area || listing.metadata?.area || (listing.features && listing.features.area);
                    if (!listingArea) continue;
                    
                    const numericArea = parseAreaToNumber(listingArea);
                    if (numericArea === null || numericArea < filter.min_area) continue;
                }
                
                // Categorize by availability
                if (listing.is_available_for_dates !== false) {
                    availableListings.push(listing);
                } else {
                    unavailableListings.push(listing);
                }
            }
              // Sort each category if needed
            const orderBy = filter.order;
            if (orderBy) {
                let sortFn;
                if (orderBy === 'RECOMMENDED') {
                    sortFn = (a, b) => Number(Boolean(b.campaign_priority)) - Number(Boolean(a.campaign_priority)) || (parseFloat(a.price) - parseFloat(b.price));
                } else if (orderBy.startsWith('PRICE_')) {
                    const sortDirection = orderBy === 'PRICE_ASC' ? 'asc' : 'desc';
                    sortFn = (a, b) => {                        const aPrice = parseFloat(a.price) || 0;
                        const bPrice = parseFloat(b.price) || 0;
                        return sortDirection === 'asc' ? aPrice - bPrice : bPrice - aPrice;
                    };                } else if (orderBy === 'DISTANCE_ASC' && filter.lat && filter.lng) {
                    // Distance-based sorting using pre-calculated distance
                    // Distance is calculated during filtering above to avoid duplication
                    sortFn = (a, b) => {
                        const distanceA = a.calculatedDistance !== undefined ? a.calculatedDistance : Infinity;
                        const distanceB = b.calculatedDistance !== undefined ? b.calculatedDistance : Infinity;
                        return distanceA - distanceB; // Ascending order (nearest first)
                    };
                }
                if (sortFn) {
                    availableListings.sort(sortFn);
                    unavailableListings.sort(sortFn);
                }
            }
            
            // Combine with available listings first
            return [...availableListings, ...unavailableListings];
        };

        this.resetFilter = (event, value) => {
            defaultFilter.min_area = null;
            let filter = _.cloneDeep(defaultFilter);
            let listings = _.cloneDeep(window.defaultListings);
            this.setState({filter: filter, listings: listings});
            
            // Update map with reset filter
            if (window.map && typeof window.populateMapWithListings === 'function') {
                window.populateMapWithListings(window.map, defaultFilter.type, defaultFilter);
            }
        };

        // Helper method to sync UI elements with filter state (used only for specific cases)
        this.syncUIWithFilterState = () => {
            // Reset map dropdown filters
            const $mapDropdown = window.$ ? window.$('#mapPropertyType') : null;
            if ($mapDropdown && $mapDropdown.length) {
                $mapDropdown.val(this.state.filter.type || 'All');
                $mapDropdown.trigger('change');
            }

            const $mapMinSize = window.$ ? window.$('#mapMinSize') : null;
            if ($mapMinSize && $mapMinSize.length) {
                $mapMinSize.val(this.state.filter.min_area ? this.state.filter.min_area.toString() : 'Any');
            }

            // Note: Date syncing removed since we no longer reset dates when location changes
        };
    }

    componentDidMount() {
        // Always start by loading all listings first
        let url = '/api/listings/filter';
        
        axios
            .get(url)
            .then(
                result => {
                    let listings = result.data;
                    window.defaultListings = listings;
                    this.setState({ 'listings': listings}); // Set directly first
                    
                    // Check if we have coordinate-based filtering from URL parameters
                    const hasCoordinateFilter = this.state.filter.lat && this.state.filter.lng;
                    
                    // Adjust default sort order based on coordinate availability
                    let filterUpdate = {};
                    if (!hasCoordinateFilter && this.state.filter.order === 'DISTANCE_ASC') {
                        // No coordinates available, fallback to price sorting
                        filterUpdate.order = 'RECOMMENDED';
                    }
                    
                    // Update filter if needed and then process
                    if (Object.keys(filterUpdate).length > 0) {
                        const newFilter = {
                            ...this.state.filter,
                            ...filterUpdate
                        };
                        this.setState({ filter: newFilter }, () => {
                            // Process after filter state is updated
                            if (hasCoordinateFilter) {
                                this.fetchListings();
                            } else {
                                this.filter();
                            }
                        });
                    } else {
                        // No filter update needed, process immediately
                        if (hasCoordinateFilter) {
                            setTimeout(() => {
                                this.fetchListings();
                            }, 0);
                        } else {
                            setTimeout(() => {
                                this.filter();
                            }, 0);
                        }
                    }
                      // Defer map population
                    setTimeout(() => {
                        if (window.map && typeof window.populateMapWithListings === 'function') {
                            window.populateMapWithListings(window.map, this.state.filter.type, this.state.filter);
                        }
                    }, 100);
                    
                    // Defer other setup
                    setTimeout(() => {
                        const $mapDropdown = window.$ ? window.$('#mapPropertyType') : null;
                        if ($mapDropdown && $mapDropdown.length) {
                            $mapDropdown.val(this.state.filter.type);
                            
                            // Also sync the map min_area dropdown before triggering change
                            const $mapMinSize = window.$ ? window.$('#mapMinSize') : null;
                            if ($mapMinSize && $mapMinSize.length && this.state.filter.min_area) {
                                $mapMinSize.val(this.state.filter.min_area.toString());
                            }
                            
                            $mapDropdown.trigger('change');
                        }
                        setupScrollListener();
                    }, 200);
                    
                    // Reduce LazyLoad checks
                    setTimeout(() => {
                        forceCheck();
                    }, 500);
                },
                error => {
                    console.error('Error loading listings:', error);
                    // Handle error state if needed
                    window.defaultListings = []; // Ensure it's empty on error
                    this.setState({ 'listings': [] });
                }
            );
        
        // Force check on window resize - especially important for mobile orientation changes
        window.addEventListener('resize', () => {
            forceCheck();
        });
        
        // Listen for address selection events from the address autocomplete component
        this.addressSelectionHandler = (event) => {
            this.handleAddressChange(event.detail);
        };
        document.addEventListener('addressSelected', this.addressSelectionHandler);
          window.setListingsTypeFilter = (value) => {
            // Only update if different
            if (this.state.filter.type !== value) {
                this.toggleType(null, null, value);
            }
        };
        
        window.getCurrentListingsFilter = () => {
            return this.state.filter;
        };
    }

    componentWillUnmount() {
        // Cancel any ongoing request
        if (this.currentRequest) {
            this.currentRequest.cancel('Component unmounting');
        }
        
        // Clear timeouts
        if (this.dateFilterTimeout) {
            clearTimeout(this.dateFilterTimeout);
        }
        
        // Remove address selection event listener
        if (this.addressSelectionHandler) {
            document.removeEventListener('addressSelected', this.addressSelectionHandler);
        }
        
        // Clear cache if it gets too large (prevent memory leaks)
        if (areaParsingCache.size > 1000) {
            areaParsingCache.clear();
        }
    }

    render() {
        const { filter, listings, isLoadingWithDates } = this.state;
        
        // Add mobile padding styles
        const containerStyle = {
            paddingLeft: window.innerWidth < 766 ? '15px' : '0',
            paddingRight: window.innerWidth < 766 ? '15px' : '0'
        };return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <div className="row">                    <div className="col-sm-12" style={containerStyle}>
                        {/* Filter and Map Container */}
                        <div style={{
                            display: 'flex',
                            flexDirection: window.innerWidth < 766 ? 'column' : 'row',
                            gap: window.innerWidth < 766 ? '30px' : '30px',
                            marginBottom: '50px',
                            alignItems: 'stretch'
                        }}>                            {/* Filter Container */}
                            <div style={{
                                flex: window.innerWidth < 766 ? 'none' : '2',
                                minWidth: 0
                            }}>
                                <Card initiallyExpanded={true} style={{
                                    borderRadius: '16px', 
                                    overflow: 'hidden',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                    border: '1px solid #e8eaed',
                                    height: '100%'
                                }}>
                                    <CardText style={{
                                        padding: '20px', 
                                        height: '100%', 
                                        display: 'flex', 
                                        flexDirection: 'column'
                                    }}>                                        {/* Row 1: Address Input (Full Width) */}
                                        <div className="row" style={{marginBottom: '16px', flex: '0 0 auto'}}>
                                            <div className="col-xs-12">
                                                <div style={{marginBottom: '12px'}}>
                                                    <label style={{display: 'block', fontSize: '12px', color: '#ff8551', marginBottom: '10px', fontWeight: '500'}}>
                                                        Location
                                                    </label>
                                                    <AddressInput
                                                        value={this.state.filter.address || ''}
                                                        coordinates={this.state.filter.lat && this.state.filter.lng ? { lat: this.state.filter.lat, lng: this.state.filter.lng } : null}
                                                        onChange={this.handleAddressChange}
                                                        placeholder="Enter your location (e.g. Auckland, Wellington)"
                                                        inputStyle={{
                                                            fontSize: '14px',
                                                            padding: '14px',
                                                            border: '2px solid #e8eaed',
                                                            borderRadius: '10px'
                                                        }}
                                                    />
                                                    {this.state.filter.address && (
                                                        <div style={{fontSize: '11px', color: '#999', marginTop: '4px'}}>
                                                            Using location-based search within {this.state.filter.radius || 50}km radius
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Row 2: Date Filters */}
                                        <div className="row" style={{marginBottom: '16px'}}>
                                            <div className="col-xs-12 col-sm-6">
                                                <div style={{marginBottom: '12px'}}>
                                                    <label style={{display: 'block', fontSize: '12px', color: '#ff8551', marginBottom: '10px', fontWeight: '500'}}>
                                                        Start Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        aria-label="Storage start date"
                                                        value={this.state.filter.start_date || ''}
                                                        onChange={(e) => this.handleDateChange('start_date', e.target.value)}
                                                        min={new Date().toISOString().split('T')[0]}
                                                        style={{
                                                            width: '100%',
                                                            padding: '14px',
                                                            border: '2px solid #e8eaed',
                                                            borderRadius: '10px',
                                                            fontSize: '14px',
                                                            transition: 'border-color 0.2s ease',
                                                            outline: 'none'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-6">
                                                <div style={{marginBottom: '12px'}}>
                                                    <label style={{display: 'block', fontSize: '12px', color: '#ff8551', marginBottom: '10px', fontWeight: '500'}}>
                                                        End Date (optional)
                                                    </label>
                                                    <input
                                                        type="date"
                                                        aria-label="Storage end date (optional)"
                                                        value={this.state.filter.end_date || ''}
                                                        onChange={(e) => this.handleDateChange('end_date', e.target.value)}
                                                        min={this.state.filter.start_date || new Date().toISOString().split('T')[0]}
                                                        disabled={!this.state.filter.start_date}
                                                        style={{
                                                            width: '100%',
                                                            padding: '14px',
                                                            border: '2px solid #e8eaed',
                                                            borderRadius: '10px',
                                                            fontSize: '14px',
                                                            transition: 'border-color 0.2s ease',
                                                            outline: 'none',
                                                            opacity: !this.state.filter.start_date ? 0.5 : 1
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            {this.state.filter.start_date && (
                                                <div className="col-xs-12">
                                                    <div style={{marginTop: '8px'}}>
                                                        <button
                                                            type="button"
                                                            onClick={() => this.handleDateChange('start_date', '') || this.handleDateChange('end_date', '')}
                                                            style={{
                                                                padding: '8px 16px',
                                                                fontSize: '12px',
                                                                color: '#666',
                                                                backgroundColor: '#f8f9fa',
                                                                border: '1px solid #e8eaed',
                                                                borderRadius: '8px',
                                                                cursor: 'pointer',
                                                                transition: 'all 0.2s ease'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.backgroundColor = '#e9ecef';
                                                                e.target.style.borderColor = '#d1d8dd';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.backgroundColor = '#f8f9fa';
                                                                e.target.style.borderColor = '#e8eaed';
                                                            }}
                                                        >
                                                            Clear dates
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* Row 3: Storage Type and Minimum Size */}
                                        <div className="row" style={{marginBottom: '16px'}}>
                                            <div className="col-xs-12 col-sm-6">
                                                <SelectField
                                                    id="listingsPropertyType"
                                                    floatingLabelText="Storage Type"
                                                    floatingLabelStyle={menuItemStyle}
                                                    floatingLabelFixed={true}
                                                    selectedMenuItemStyle={menuItemStyle}
                                                    value={this.state.filter.type}
                                                    onChange={this.toggleType}
                                                    hintText="Please select"
                                                    style={{width: '100%'}}>
                                                    {storageTypes.map((el, i) => <MenuItem value={el} key={i} primaryText={el} />)}
                                                </SelectField>
                                            </div>

                                            <div className="col-xs-12 col-sm-6">
                                                <SelectField
                                                    floatingLabelText="Minimum Size"
                                                    floatingLabelStyle={menuItemStyle}
                                                    floatingLabelFixed={true}
                                                    selectedMenuItemStyle={menuItemStyle}
                                                    value={getNearestMinAreaOption(this.state.filter.min_area)}
                                                    onChange={this.toggleMinArea}
                                                    hintText="Please select"
                                                    style={{width: '100%'}}>
                                                    {minAreaOptions.map((option, i) => <MenuItem value={option.value} key={i} primaryText={option.label} />)}
                                                </SelectField>
                                            </div>
                                        </div>
                                    </CardText>
                                </Card>
                            </div>                            {/* Map Container */}
                            <div style={{
                                flex: window.innerWidth < 766 ? 'none' : '1',
                                minWidth: window.innerWidth < 766 ? 'auto' : '300px',
                                height: window.innerWidth < 766 ? '320px' : 'auto'
                            }}>
                                <div 
                                    className="card-map"
                                    onClick={() => window.openMap(this.state.filter.location, this.state.filter.lat, this.state.filter.lng)}
                                    style={{
                                        position: 'relative',
                                        cursor: 'pointer',
                                        borderRadius: '16px',
                                        overflow: 'hidden',
                                        height: '100%',
                                        background: '#f8f9fa',
                                        border: '1px solid #e8eaed',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                    }}
                                >
                                    <img 
                                        src="/images/staticmap.jpg" 
                                        alt="Map view"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'linear-gradient(135deg, rgba(66, 82, 178, 0.1) 0%, rgba(66, 82, 178, 0.05) 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>                                        <button 
                                            className="btn btn-primary"
                                            style={{
                                                padding: '14px 24px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                borderRadius: '12px',
                                                border: 'none',
                                                background: 'linear-gradient(135deg, #ff8551 0%, #f76164 100%)',
                                                color: 'white',
                                                boxShadow: '0 4px 20px rgba(255, 133, 81, 0.3)',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.boxShadow = '0 6px 25px rgba(255, 133, 81, 0.4)';
                                                e.target.style.background = 'linear-gradient(135deg, #f76164 0%, #ff8551 100%)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.boxShadow = '0 4px 20px rgba(255, 133, 81, 0.3)';
                                                e.target.style.background = 'linear-gradient(135deg, #ff8551 0%, #f76164 100%)';
                                            }}
                                        >
                                            <i className="fa fa-map" style={{marginRight: '8px'}}></i>
                                            Map view
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                        {/* Sort Options - positioned above listings */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginBottom: '20px',
                            marginTop: '20px',
                            paddingRight: '15px'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}>                                
                            <span style={{
                                    fontSize: '14px',
                                    color: '#666',
                                    fontWeight: '500',
                                    lineHeight: '36px',
                                    marginBottom: '-20px',
                                    display: 'inline-block'
                                }}>
                                    Sort by:
                                </span><SelectField
                                    value={this.state.filter.order}
                                    onChange={this.toggleOrder}
                                    underlineStyle={{display: 'none'}}
                                    style={{
                                        width: '180px',
                                        fontSize: '14px',
                                        height: '36px',
                                        marginBottom: '-22px'
                                    }}
                                    labelStyle={{
                                        fontSize: '14px',
                                        color: '#333',
                                        paddingLeft: '12px',
                                        paddingRight: '24px',
                                        lineHeight: '36px'
                                    }}                                    
                                    menuStyle={{
                                        marginTop: '4px'
                                    }}                                      
                                    iconStyle={{
                                        fill: '#666',
                                        right: '8px',
                                        padding: '0px',
                                        marginTop: '-5px',
                                    }}                                    selectedMenuItemStyle={{
                                        color: '#ff8551'
                                    }}>
                                    {this.state.filter.lat && this.state.filter.lng && (
                                        <MenuItem value="DISTANCE_ASC" primaryText="Nearest Location" />
                                    )}
                                    <MenuItem value="RECOMMENDED" primaryText="Recommended" />
                                    <MenuItem value="PRICE_ASC" primaryText="Price: Low to High" />
                                    <MenuItem value="PRICE_DESC" primaryText="Price: High to Low" />
                                </SelectField>
                            </div>
                        </div>

                        <div className="row listings-container" style={{
                            margin: '0', 
                            marginLeft: window.innerWidth >= 766 ? '0' : '0',
                            marginRight: window.innerWidth >= 766 ? '0' : '0'
                        }}>
                            {this.state.isLoadingWithDates ? (
                                <div className="col-sm-12" style={{
                                    textAlign: 'center',
                                    padding: '60px 20px',
                                    color: '#666'
                                }}>
                                    <div style={{
                                        display: 'inline-block',
                                        animation: 'spin 1s linear infinite',
                                        width: '40px',
                                        height: '40px',
                                        border: '4px solid #f3f3f3',
                                        borderTop: '4px solid #ff8551',
                                        borderRadius: '50%',
                                        marginBottom: '20px'
                                    }}></div>
                                    <h3 style={{
                                        color: '#ff8551',
                                        fontSize: '24px',
                                        fontWeight: '600',
                                        margin: '0 0 10px 0'
                                    }}>Finding Storage...</h3>
                                    <p style={{
                                        fontSize: '16px',
                                        margin: '0',
                                        color: '#666'
                                    }}>Checking availability for your selected dates</p>
                                    <style>{`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg); }
                                            100% { transform: rotate(360deg); }
                                        }
                                    `}</style>
                                </div>
                            ) : defaultListings.length > 0
                                ? this.state.listings.length > 0
                                    ? (this.state.listings.map((el, i) => (
                                        <div className="col-sm-6 col-md-4" key={i} style={{
                                            marginBottom: '30px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px'
                                        }}>                                            <Listing 
                                                item={el} 
                                                filterType={this.state.filter.type} 
                                                filterStartDate={this.state.filter.start_date}
                                                filterEndDate={this.state.filter.end_date}
                                                key={el.slug}
                                                enhancedStyles={getEnhancedStyles()}
                                            />
                                        </div>
                                    )))
                                    : (
                                        <div className="col-sm-12">
                                            <h2>No listings match your filters.</h2>
                                            <p>Sorry, there are no results for your current filter selections. <br />Reset your filters to something less specific, otherwise contact us directly and we can help you find what you need.</p>
                                            <RaisedButton label="Reset filters" primary={true} onTouchTap={this.resetFilter} className="xs-mr-20 xs-mb-20"/>
                                        </div>
                                    )
                                : (<div className="col-sm-12">Loading...</div>)}
                        </div>
                    </div>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default Listings;

// Add new hover style function to use with components
function getEnhancedStyles() {
    return {
        listingCard: {
            borderRadius: 8,
            overflow: 'hidden',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
            height: '100%',
            backgroundColor: '#fff'
        },
        listingCardHover: {
            boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
            transform: 'translateY(-5px)'
        },
        imageContainer: {
            height: 180,
            overflow: 'hidden',
            position: 'relative'
        },
        statusBadge: {
            backgroundColor: '#FF6F61', // $brand-secondary
            color: 'white',
            padding: '3px 8px',
            borderRadius: 4,
            fontSize: 12,
            fontWeight: 600,
            display: 'inline-block',
        },
        actionButtons: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: 16,
        },
        button: {
            height: 46,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }
    };
}

// Add this scroll handler function after the class definition
function setupScrollListener() {
  let lastScrollTop = 0;
  let scrollTimer;
  
  const handleScroll = () => {
    clearTimeout(scrollTimer);
    
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (Math.abs(lastScrollTop - st) > 100) { // Increased threshold from 50 to 100
      forceCheck();
      lastScrollTop = st;
    }
    
    scrollTimer = setTimeout(() => {
      forceCheck();
    }, 300); // Increased delay from 100 to 300
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('touchmove', handleScroll, { passive: true });
  window.addEventListener('resize', forceCheck);
  
  // Reduce initial checks
  setTimeout(forceCheck, 500);
  setTimeout(forceCheck, 1500);
}

// Optimized single-pass filtering and sorting
Listings.prototype.processSinglePassFilter = function(listings) {
    const { filter } = this.state;

    const availableListings = [];
    const unavailableListings = [];
    
    // Single pass through listings - filter and categorize simultaneously
    for (let i = 0; i < listings.length; i++) {
        const listing = listings[i];
        
        // Apply area filter if needed
        if (filter.min_area) {
            const listingArea = listing.area || listing.metadata?.area || (listing.features && listing.features.area);
            if (!listingArea) continue; // Skip listings without area info
            
            const numericArea = parseAreaToNumber(listingArea);
            if (numericArea === null || numericArea < filter.min_area) {
                continue; // Skip listings that don't meet area requirement
            }
        }
        
        // Categorize by availability - preserve availability_state from API
        if (listing.is_available_for_dates !== false) {
            availableListings.push(listing);
        } else {
            unavailableListings.push(listing);
        }
    }
      // Sort each category if needed
    const orderBy = filter.order;

    if (orderBy) {
        let sortFn;
        if (orderBy === 'RECOMMENDED') {
                    sortFn = (a, b) => Number(Boolean(b.campaign_priority)) - Number(Boolean(a.campaign_priority)) || (parseFloat(a.price) - parseFloat(b.price));
                } else if (orderBy.startsWith('PRICE_')) {
            const sortDirection = orderBy === 'PRICE_ASC' ? 'asc' : 'desc';
            sortFn = (a, b) => {
                const aPrice = parseFloat(a.price) || 0;
                const bPrice = parseFloat(b.price) || 0;                return sortDirection === 'asc' ? aPrice - bPrice : bPrice - aPrice;
            };        } else if (orderBy === 'DISTANCE_ASC' && filter.lat && filter.lng) {
            // Distance-based sorting using Haversine formula
            const userLat = filter.lat;
            const userLng = filter.lng;
            
            const calculateDistance = (listing) => {
                try {
                    const listingLat = listing.latitude;
                    const listingLng = listing.longitude;

                    if (!listingLat || !listingLng) {
                        return Infinity; // Put listings without coordinates at the end
                    }
                    
                    // Haversine formula for distance calculation
                    const R = 6371; // Earth's radius in kilometers
                    const dLat = (listingLat - userLat) * Math.PI / 180;
                    const dLng = (listingLng - userLng) * Math.PI / 180;
                    const a = 
                        Math.sin(dLat/2) * Math.sin(dLat/2) +
                        Math.cos(userLat * Math.PI / 180) * Math.cos(listingLat * Math.PI / 180) * 
                        Math.sin(dLng/2) * Math.sin(dLng/2);
                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                    const distance = R * c;

                    return distance;
                } catch (e) {
                    return Infinity; // Put errored listings at the end
                }
            };
            
            sortFn = (a, b) => {
                const distanceA = calculateDistance(a);
                const distanceB = calculateDistance(b);
                return distanceA - distanceB; // Ascending order (nearest first)
            };
        }
        if (sortFn) {
            availableListings.sort(sortFn);
            unavailableListings.sort(sortFn);
        }
    }
    
    // Combine with available listings first
    return [...availableListings, ...unavailableListings];
};
